import Vue from "vue";
import axios from "axios";
import accessToken from "@/services/accessToken";
import { WORKMAN_URL } from "@/const";

// Global variables
axios.defaults.baseURL = WORKMAN_URL;
window.axios = axios;
window.accessToken = accessToken;
window.WORKMAN_URL = WORKMAN_URL;
window.WORKMAN_WS = WORKMAN_URL.replace("http", "ws");

import App from "./App.vue";
import store from "./store/index";
import router from "./router";
import mixin from './mixin'
import VeeValidate from "vee-validate";
import VueGoogleCharts from "vue-google-charts";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import dayjs from "dayjs";
import moment from "moment";
import VueMoment from "vue-moment";
import Loading from "vue-loading-overlay"

import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import 'bootstrap-icons/font/bootstrap-icons.css';

import "@fortawesome/fontawesome-free/css/all.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

import "./assets/stylesheets/dashboard.css";
import "./assets/stylesheets/admin.css"; // admin page stylesheets
import "./assets/stylesheets/sass/main.scss";

// ESG Sidebar
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

import Multiselect from 'vue-multiselect';

axios.interceptors.response.use(
  response => {
    return Promise.resolve(response);
  },
  error => {
    if (error && error.response) {
      const { status } = error.response;
      error.status = status;
      if (error.response.data) {
        if (error.response.data.body && error.response.data.body.message) {
          error.message = error.response.data.body.message;
        } else if (error.response.data.message) {
          error.message = error.response.data.message.split("\n")[0]; // 401 일 때도 로그인 실패 시 이유를 보여주기 위해서 필요함
        }
      } else {
        error.message = "Unknown Error";
      }
    }
    return Promise.reject(error);
  }
);

// Plugins
Vue.use(VueGoogleCharts);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VeeValidate, { fieldsBagName: "veeFields", errorBagName: "errors" });
Vue.use(VueMoment, { moment });
Vue.use(VueSidebarMenu);
Vue.use(VueGoogleCharts)
Vue.use(VueApexCharts)
Vue.use(dayjs)

// Global components
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('apex-chart', VueApexCharts)
Vue.component('dayjs', dayjs)
Vue.component('loading', Loading)

Vue.component('multiselect', Multiselect);

// Apex chart global options
Apex.chart = {
  fontFamily: 'NanumGothic',
};
Apex.colors = store.getters['ghg/colors'];
Apex.states = {
  hover: { filter: { type: 'none' } },
  active: { filter: { type: 'none' } },
}
Apex.plotOptions = {
  bar: {
    columnWidth: '40%',
  },
  pie: {
    donut: {
      size: '70%'
    }
  }
}
Apex.noData = {
  text: '조회 결과가 없습니다',
}
Apex.dataLabels = {
  style: {
    fontWeight: 400,
    colors: ['#FFF']
  },
  background: {
    enabled: false,
  }
}


// Mixin
Vue.mixin(mixin);

// Mount
let app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");

window.app = app
